<template>
  <div class="admin-translate">
    <header-title title="Traducciones Comida"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="food in paginatedData" :key="food.id">
          <TranslateCartasPrincipales
            :data="food"
            @saveToCollection="saveToFoodCollection"
          ></TranslateCartasPrincipales>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredFood.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import TranslateCartasPrincipales from "@/components/admin/translate/TranslateCartasPrincipales";
import { foodCollection, updateFood } from "@/collections/food";

export default {
  name: "TranslateFood",
  components: {
    HeaderTitle,
    Loader,
    TranslateCartasPrincipales
  },
  data() {
    return {
      dialogLoader: false,
      search: "",
      foodCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      foodCollection: foodCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredFood() {
      let _food = [...this.foodCollection];
      _food = [
        ..._food.map(food => {
          food.ingredients.map(ingredient => {
            return (ingredient.trans = {
              en: ingredient.trans ? ingredient.trans.en : ingredient.item,
              es: ingredient.trans ? ingredient.trans.es : ingredient.item,
              it: ingredient.trans ? ingredient.trans.it : ingredient.item,
              fr: ingredient.trans ? ingredient.trans.fr : ingredient.item,
              de: ingredient.trans ? ingredient.trans.de : ingredient.item
            });
          });
          return food;
        })
      ];
      return this.search
        ? _food.filter(food =>
            food?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _food;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredFood.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToFoodCollection(input) {
      try {
        updateFood(input.id, input);
        this.showSuccessMessage("Traducciones Comida actualizado");
      } catch (error) {
        this.setlogError(
          "save/update_food",
          "Obtained error message in saveToFoodCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
